import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import * as ELG from 'esri-leaflet-geocoder';
import env from '../../Confgs/vars';

interface Props {
  onSelect: (result: { lat: number; lon: number; label: string }) => void;
}

export default function SearchBar({ onSelect }: Props) {
  const map = useMap();
  const controlRef = useRef<any>(null);
  const resultsRef = useRef<L.LayerGroup | null>(null);

  // Simpan onSelect terbaru
  const onSelectRef = useRef(onSelect);
  useEffect(() => {
    onSelectRef.current = onSelect;
  }, [onSelect]);

  useEffect(() => {
    if (!map || controlRef.current) return;

    const control = (ELG as any).geosearch({
      position: 'topleft',
      placeholder: 'Cari lokasi...',
      useMapBounds: false,
      collapseAfterResult: false,
      expanded: true,
      providers: [
        (ELG as any).arcgisOnlineProvider({
          apikey: env?.apiKeyArcGis,
        }),
      ],
    }).addTo(map);

    const results = L.layerGroup().addTo(map);

    controlRef.current = control;
    resultsRef.current = results;

    const handleResults = (data: any) => {
      results.clearLayers();
      if (data.results.length) {
        const firstResult = data.results[0];
        const latlng = firstResult.latlng;

        // ✅ pakai ref, bukan prop langsung
        onSelectRef.current({
          lat: latlng.lat,
          lon: latlng.lng,
          label: firstResult.text,
        });
      }
    };

    control.on('results', handleResults);

    return () => {
      control.off('results', handleResults);
      map.removeControl(control);
      map.removeLayer(results);
      controlRef.current = null;
      resultsRef.current = null;
    };
  }, [map]);

  return null;
}


// import { useEffect, useRef } from 'react';
// import { useMap } from 'react-leaflet';
// import L from 'leaflet';
// import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
// import * as ELG from 'esri-leaflet-geocoder';
// import env from '../../Confgs/vars';

// interface Props {
//   onSelect: (result: { lat: number; lon: number; label: string }) => void;
// }

// export default function SearchBar({ onSelect }: Props) {
//   const map = useMap();
//   const controlRef = useRef<any>(null);
//   const resultsRef = useRef<L.LayerGroup | null>(null);

//   useEffect(() => {
//     if (!map || controlRef.current) return;

//     const control = (ELG as any).geosearch({
//       position: 'topleft',
//       placeholder: 'Cari lokasi...',
//       useMapBounds: false,
//       collapseAfterResult: false,
//       expanded: true,
//       providers: [
//         (ELG as any).arcgisOnlineProvider({
//           apikey: env?.apiKeyArcGis,
//         }),
//       ],
//     }).addTo(map);

//     const results = L.layerGroup().addTo(map);
    
//     controlRef.current = control;
//     resultsRef.current = results;

//     const handleResults = (data: any) => {
//       results.clearLayers();
//       if (data.results.length) {
//         const firstResult = data.results[0];
//         const latlng = firstResult.latlng;
//         onSelect({
//           lat: latlng.lat,
//           lon: latlng.lng,
//           label: firstResult.text
//         });
//       }
//     };

//     control.on('results', handleResults);

//     return () => {
//       if (controlRef.current) {
//         map.removeControl(controlRef.current);
//         controlRef.current.off('results', handleResults);
//         controlRef.current = null;
//       }
//       if (resultsRef.current) {
//         resultsRef.current.clearLayers();
//         map.removeLayer(resultsRef.current);
//         resultsRef.current = null;
//       }
//     };
//   }, [map]); // Hanya depend pada map, bukan onSelect

//   return null;
// }
